<template>
  <donut-form
    ref="form"
    :action="`/journey_builder/${workflow.id}/submit_goals`"
  >
    <div v-for="(goal, idx) in workflow.goals.filter(g => g.selected)" :key="`goal-${idx}`">
      <input type="hidden" name="workflow[goals][][id]" :value="goal.id">
      <input type="hidden" name="workflow[goals][][text]" :value="goal.text">
    </div>
    <journey-builder-workflows-form
      ref="workflowsFormComponent"
      title="What do you want to accomplish with this Journey?"
      :subtitle="`${workflow.assets.length ? 'Based on your documents, w' : 'W'}e preselected these goals for your Journey`"
      :is-save-disabled="isSaveDisabled"
      :back-url="`/journey_builder?workflow_id=${workflow.id}`"
      back-text="Back"
      @save="submitForm"
    >
      <template #topSection>
        <donut-checkbox-grid
          :items="goalCards"
          input-name="workflow[goals][]"
        >
          <template #addNew>
            <span class="white f-h f-ac">
              <i class="mi md-36">add</i>
              <p class="m-lx1 t bold">Add New</p>
            </span>
          </template>
        </donut-checkbox-grid>
      </template>
    </journey-builder-workflows-form>
  </donut-form>
</template>

<script setup>
  import { computed, onMounted, ref, watch, nextTick } from 'vue';
  import { useStore } from 'vuex';
  import useClientState from '../../../composables/client-state';

  const { setSessionStorage, removeSessionStorage } = useClientState();
  const { commit, state } = useStore();

  const props = defineProps({
    workflow: { type: Object, required: true },
  });
  const workflow = ref(props.workflow);
  const workflowsFormComponent = ref(null);
  const form = ref(null);

  const openAddGoalModal = () => {
    commit('updateModal', {
      visible: true,
      subcomponent: 'journey-builder-workflows-modals-add-goal',
      data: { goals: workflow.value.goals },
    });
  };

  const goalCards = computed(() => [
    { filled: true, slotName: 'addNew', onClick: openAddGoalModal },
    ...workflow.value.goals,
  ]);

  const isSaveDisabled = computed(() => !workflow.value.goals.filter(g => g.selected).length);

  const submitForm = () => {
    removeSessionStorage('journeyBuilderWorkflow');
    form.value.submit();
  };

  watch(goalCards, (newValue) => {
    if (newValue) {
      nextTick(() => {
        // Scroll to the bottom of the page so the new card is visible.
        document.body.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      });
    }
  });

  onMounted(() => {
    // So that if the user goes back in the browser to user_inputs we can re-populate their data.
    setSessionStorage('journeyBuilderWorkflow', JSON.stringify({ id: props.workflow.id }));
  });
</script>
